module.exports = __webpack_public_path__ + "assets/img/ic-reply-hover.3c4df565.svg";